import {
  absoluteImage,
  absoluteUrl,
  DEFAULT_SEO_PUBLISHER,
  stripHtml,
} from "../config/seo";

const truncate = (s: string, maxLen: number) => {
  const text = s?.trim() || "";
  if (!text) return "";
  if (text.length <= maxLen) return text;
  return `${text.slice(0, maxLen).trim()}...`;
};

export const buildarticlesDescription = (article: any) => {
  const html =
    article?.pageDescription ||
    article?.articleContent ||
    "";

  const text = stripHtml(html);
  return truncate(text, 160);
};

export const buildarticlesKeywords = (article: any) => {
  const parts = [
    article?.author,
    article?.articleLanguage,
    article?.name,
  ]
    .map((v) => (v ? String(v).trim() : ""))
    .filter(Boolean);

  const uniq: string[] = [];

  for (const p of parts) {
    if (!uniq.some((x) => x.toLowerCase() === p.toLowerCase())) {
      uniq.push(p);
    }
  }

  return uniq.join(", ");
};

export const buildarticlesJsonLd = (
  article: any,
  canonicalPath: string
) => {
  const url = absoluteUrl(canonicalPath);

  const image = article?.ogImage
    ? absoluteImage(article.ogImage)
    : "";

  const description =
    buildarticlesDescription(article);

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: article?.name,
    description,
    image,
    url,
    author: article?.author
      ? {
          "@type": "Person",
          name: article.author,
        }
      : undefined,
    inLanguage: article?.articleLanguage,
    publisher: {
      "@type": "Organization",
      name: DEFAULT_SEO_PUBLISHER,
    },
  };

  return jsonLd;
};